import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { ClientForm } from '@/components/forms/ClientForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function CreateClientPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()

  const handleSuccess = () => {
    navigate('/organization/clients')
  }

  const handleCancel = () => {
    navigate('/organization/clients')
  }

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Create New Client</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Create a new client tenant. A SIMA database will be provisioned automatically after saving.
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <ClientForm onSuccess={handleSuccess} onCancel={handleCancel} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}
